import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a1a1a] py-8 border-t border-white/10" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-11">
          <span className="text-brand-cream/60 text-center md:text-left" data-id="element-12">
            © 2026 Market on 8th. All rights reserved. · 41 E. 8th St.,
            National City, CA 91950
          </span>
          <span className="font-display font-bold tracking-widest text-brand-gold uppercase text-center" data-id="element-13">
            EAT. DRINK. MINGLE.
          </span>
          <a href="https://www.instagram.com/marketon8thst/" target="_blank" rel="noopener noreferrer" className="text-brand-cream/60 hover:text-brand-white transition-colors text-center" data-id="element-14">
            @marketon8thst
          </a>
        </div>
      </div>
    </footer>;
}